import { v4 as uuid } from 'uuid';
export class I18NSettings {
    enableAutomaticTranslation = false;
    hideTranslationTabs = false;
    defaultLanguage = 'es';
    languages = [];
}
export class I18NLanguage {
    name;
    enabled;
    isDefault;
    constructor(name, enabled, isDefault) {
        this.name = name;
        this.enabled = enabled;
        this.isDefault = isDefault;
    }
}
export class VatRate {
    id;
    name = null;
    rate = null;
    isDefault = false;
    constructor(id, data) {
        if (id && typeof id == 'string') {
            this.id = id;
        }
        else if (id && typeof id == 'object' && typeof id.id == 'string') {
            this.id = id.id;
        }
        else {
            this.id = uuid();
        }
        if (id && typeof id == 'object') {
            data = id;
        }
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export var InvoiceCreationTriggerType;
(function (InvoiceCreationTriggerType) {
    InvoiceCreationTriggerType["manual"] = "manual";
    InvoiceCreationTriggerType["orderReceived"] = "order-received";
    InvoiceCreationTriggerType["orderPaid"] = "order-paid";
    InvoiceCreationTriggerType["onDone"] = "on-done";
})(InvoiceCreationTriggerType || (InvoiceCreationTriggerType = {}));
export class Settings {
    companyId;
    vatRates = [];
    sendNewOrderNotifications = true;
    vatForTips = null;
    timezone = 'Europe/Vienna';
    vat = null;
    stripeSecretKey = null;
    stripePublishableKey = null;
    tipIsTaxed = false;
    sendCopyOfOrderReceipts = false;
    sendNewOrderNotificationsTo = null;
    currency = 'EUR';
    sendCopyOfOrderReceiptsTo = null;
    expectedDeliveryNotice = null;
    defaultPointofsaleId = null;
    sendSMSOnOrderReady = false;
    tipIsEnabled = false;
    defaultTipPercentage = 10;
    throttleLimit = null;
    throttleMessage = null;
    vatId = null;
    enableOfflinePayments = false;
    enableOfflinePaymentsConfirmation = false;
    legalAgePopupPositiveButtonLabel = null;
    legalAgePopupNegativeButtonLabel = null;
    enableLegalAgePopup = false;
    legalAgePopupContent = null;
    enableAccountSystem = false;
    //when false only customers that already have an account can request a login link,
    //new email addresses are not turned into accounts anymore. defaults to true so
    //companies that never touched the setting keep their open registration
    allowCustomerRegistration = true;
    enableSlotLimits = false;
    allowedNumberOfOrdersPerSlot = null;
    enableThrottleMessage = false;
    isOpen = false;
    isClosedMessage = null;
    i18n = null;
    openingHours = [];
    deliveryZones = [];
    pickupLocations = [];
    timeTables = [];
    taxAuthority = null;
    markAsPaidOnInvoiceCreation = false;
    invoiceCreationTrigger = InvoiceCreationTriggerType.orderPaid;
    simplifiedInvoiceTreshold = null;
    accentColor = null;
    headlineFont = null;
    bodyFont = null;
    splashImage = null;
    logoImage = null;
    splashTagline = null;
    theme = null;
    constructor(companyId, data) {
        this.companyId = companyId;
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (keyIsDefinedOnInstance) {
                if (value) {
                    //replace all firebase dates with real dates
                    if (value.seconds && value.toDate) {
                        value = value.toDate();
                    }
                    if (key == 'vatRates' && value.length > 0) {
                        let items = [];
                        for (let item of value) {
                            items.push(new VatRate(item.id, item));
                        }
                        value = items;
                    }
                }
                Object.assign(this, { [key]: value });
            }
        }
    }
    getVatRateById(id) {
        if (this.vatRates == null) {
            return null;
        }
        let vatRate = this.vatRates.filter((el) => el.id == id).shift();
        return vatRate || null;
    }
    getDeliveryZoneById(id) {
        if (this.deliveryZones == null || !this.deliveryZones.length) {
            return null;
        }
        let deliveryZone = this.deliveryZones.filter((el) => el.id == id).shift();
        return deliveryZone || null;
    }
    getPickupLocationById(id) {
        if (this.pickupLocations == null || !this.pickupLocations.length) {
            return null;
        }
        let pickupLocation = this.pickupLocations.filter((el) => el.id == id).shift();
        return pickupLocation || null;
    }
}
